var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Experience","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Oktoberfest_06","transform":"translate(-753.000000, -2543.000000)","stroke":"#73C9BD","strokeWidth":"3"},React.createElement("g",{"id":"Group-2","transform":"translate(660.000000, 2532.000000)"},React.createElement("g",{"id":"arrow","transform":"translate(95.000000, 12.500000)"},[React.createElement("path",{"d":"M0.5,11 L23,11.5","id":"Line-2","strokeLinecap":"square","key":0}),React.createElement("polyline",{"id":"Path-2","points":"15.5 0 24.5 11.5 15.5 22","key":1})]))))]);
}

Arrow.defaultProps = {"width":"29px","height":"25px","viewBox":"0 0 29 25","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
